module.exports = __webpack_public_path__ + "img/upload-green.815d754d.svg";